import React, {
  useCallback,
  useMemo,
  useState,
  useContext,
  useEffect
} from 'react'
import { DatePicker, Divider, Radio } from 'antd'
import moment from 'moment'

import InputWithLabel from '../../../../components/InputWithLabel'
import Modal from '../../../../components/Modal'
import ToggleSwitch from '../../../../components/ToggleSwitch'

import TermoCorridaCaminhadaDiaInternacionalMulher2022 from '../../../../termosAceite/termoCorridaCaminhadaDiaInternacionalMulher2022'

import Base from './Base'

import { FirebaseContext } from '../../../../Contexts'

const characterLimit = 255

const CorridaCaminhadaDiaInternacionalMulheres2022 = () => {
  const { firebaseFirestore: db } = useContext(FirebaseContext)

  const [mostrarTermoModal, setMostrarTermoModal] = useState(false)
  const [availableTicketsAmmount, setAvailableTicketsAmmount] = useState([])
  const [availableTicketsAmmountRef, setAvailableTicketsAmmountRef] = useState()

  const [formValues, setFormValues] = useState({
    termoAceito: false
  })

  const handleCheckedTermo = useCallback(() => {
    setFormValues((prev) => ({ ...prev, termoAceito: !prev.termoAceito }))
  }, [])

  const salvarOk = useMemo(() => {
    const {
      termoAceito
    } = formValues

    return !(
      termoAceito && availableTicketsAmmount > 0
    )
  }, [formValues, availableTicketsAmmount])

  useEffect(() => {
    const getAvailableTicketsAmmount = async () => {
      const docRef = await db
        .collection('sistema-reserva-tickets')
        .doc('corrida-caminhada-dia-internacional-mulher-2022')

      const data = await (await docRef.get()).data()

      setAvailableTicketsAmmountRef(docRef)
      setAvailableTicketsAmmount(data.quantidadeTicketsDisponiveis)
    }
    getAvailableTicketsAmmount()
  }, [])

  return (
    <Base
      description={() => (
        <div className="container">
          <div className="opcenquete align-left">
            <ToggleSwitch
              checked={formValues.termoAceito}
              setChecked={handleCheckedTermo}
              name="termoAceito"
            />
            <button
              type="button"
              className="btTransparente"
              onClick={() => {
                document.body.scrollTop = 0 // For Safari
                document.documentElement.scrollTop = 0 // FF, GC, Opera
                document.body.style.overflowY = 'hidden'
                setMostrarTermoModal(() => true)
              }}
            >
              <span className="texto-termo">
                Declaro que li e aceito os <strong>termos de privacidade</strong> da
                <strong> 10ª Corrida e Caminhada do dia Internacional da Mulher</strong>.
              </span>
            </button>
          </div>
          <div className="texto-atencao" style={{ marginTop: '14px' }}>
            {!formValues.termoAceito && (
              <span>
                <strong>Atenção</strong>: Neste caso (
                <strong>NÃO ACEITE</strong>) não será possível sua participação
                no <strong> 10ª Corrida e Caminhada do dia Internacional da Mulher</strong>. Por
                favor, em caso de dúvidas, envie uma mensagem para o aplicativo
                “Você na RPC”.
              </span>
            )}
          </div>

          {mostrarTermoModal && (
            <Modal
              setTermoAceito={handleCheckedTermo}
              setShowModal={setMostrarTermoModal}
            >
              <TermoCorridaCaminhadaDiaInternacionalMulher2022 />
            </Modal>
          )}
        </div>
      )}
      title="Corrida e Caminhada do dia Internacional da Mulher"
      imagePath="/imgs/cupons/cupom_banner_mulheres.png"
      programName="10ª Corrida e Caminhada do dia Internacional da Mulher"
      form={formValues}
      setForm={setFormValues}
      salvarOk={salvarOk}
      tipoTermo="corridaCaminhadaDiaInternacionalMulher2022"
      availableTicketsAmmountRef={availableTicketsAmmountRef}
      db={db}
      availableTicketsAmmount={availableTicketsAmmount}
    />
  )
}

export default CorridaCaminhadaDiaInternacionalMulheres2022
